"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Textarea", {
  enumerable: true,
  get: function () {
    return _Textarea.Textarea;
  }
});
var _Textarea = require("./Textarea");